module.exports = __webpack_public_path__ + "static/media/정석준.b58ae4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/정석준.png
// module id = 104
// module chunks = 0